import React from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";

import SwapCalculatorForm from "./SwapCalculatorForm";
import AnalysisResult from "./AnalysisResult";

const FormWrapper = styled(Grid)`
  height:100%;
  
`;
const ResultWrapper = styled(Grid)`  
  &&&& {
    max-width: 100%;
  }
`;
const Spacer = styled.div`
  @media only screen and (max-width: 1920px) {
    flex-grow: 0.7;
  }
  @media only screen and (max-width: 960px) {
    flex-grow: 0;    
  }
`;
class SwapCalculator extends React.Component {
  render() {
    return (
      <Grid container item xs={12} spacing={24}>
        <FormWrapper item md={7} lg={6}>
          <SwapCalculatorForm />
        </FormWrapper>
        <ResultWrapper item container direction="row" md={3} lg={6}>
          <Spacer />
          <AnalysisResult />
        </ResultWrapper>
      </Grid>
    );
  }
}

export default SwapCalculator;
